<div class="w-full px-2 md:px-4 py-3 h-full">

  <!-- Filtros -->
  <div class="filters-container">
    <div class="search-container">
      <div class="flex items-center">
        <div class="relative w-64 mr-2">
          <input type="text" placeholder="Buscar repuestos..." [(ngModel)]="searchTerm" (keyup.enter)="applySearch()"
            class="input input-bordered w-full pr-10" />
          <button (click)="clearSearch()" *ngIf="searchTerm"
            class="absolute right-10 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700">
            <i class="fas fa-times"></i>
          </button>
          <button (click)="applySearch()"
            class="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500 hover:text-blue-700">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
      <button (click)="forceReload()" class="reload-button">
        <i class="fas fa-sync-alt"></i> Recargar
      </button>
      <button (click)="copyFilteredSparePartsForWhatsapp()" class="change-status-button"
        [disabled]="loading || isCopyingWhatsapp">
        <i class="fab fa-whatsapp"></i> {{ isCopyingWhatsapp ? 'Copiando...' : 'Copiar para WhatsApp' }}
      </button>
      <button type="button"
        (click)="onlyLast60Days = !onlyLast60Days; applyOnlyLast60Days()"
        class="px-4 py-2 rounded-md transition-colors flex items-center gap-1 text-sm"
        [ngClass]="onlyLast60Days ? 'bg-amber-500 hover:bg-amber-600 text-white font-medium' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'"
        title="Mostrar solo repuestos de los últimos 60 días. Los filtros aplican sobre ese subconjunto.">
        <i class="fas fa-calendar-alt"></i>
        Solo últimos 60 días
      </button>
      <button type="button"
        (click)="onlyLowSaleRatio = !onlyLowSaleRatio; applyLowSaleRatioFilter()"
        class="px-4 py-2 rounded-md transition-colors flex items-center gap-1 text-sm"
        [ngClass]="onlyLowSaleRatio ? 'bg-rose-600 hover:bg-rose-700 text-white font-medium' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'"
        title="Mostrar solo repuestos con coeficiente V.Venta/P.Unitario menor o igual a 11.">
        <i class="fas fa-percentage"></i>
        Solo coeficiente <= 11
      </button>
      <button *ngIf="hasAnyColumnFilter" (click)="clearAllColumnFilters()"
        class="px-4 py-2 text-sm bg-red-100 hover:bg-red-200 text-red-700 rounded-md transition-colors flex items-center gap-1"
        title="Quitar todos los filtros por columna">
        <i class="fas fa-filter-circle-xmark"></i> Limpiar todos los filtros
      </button>
      <div class="relative">
        <button type="button"
          (click)="toggleColumnSelector()"
          class="px-4 py-2 text-sm bg-violet-600 hover:bg-violet-700 text-white rounded-md transition-colors flex items-center gap-1"
          title="Mostrar u ocultar columnas">
          <i class="fas fa-table-columns"></i> Columnas
        </button>
        <div *ngIf="columnSelectorOpen"
          class="absolute z-50 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg p-3 w-72">
          <div class="text-xs font-semibold text-gray-500 uppercase mb-2">Columnas visibles</div>
          <div class="max-h-64 overflow-y-auto pr-1">
            <label *ngFor="let column of columnVisibilityOptions"
              class="flex items-center gap-2 text-sm py-1 cursor-pointer hover:text-blue-700">
              <input type="checkbox"
                [checked]="isColumnVisible(column.id)"
                (change)="toggleColumnVisibility(column.id)">
              <span>{{ column.label }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="export-dropdown" [class.open]="exportMenuOpen">
        <button class="export-button"
          [disabled]="loading || filteredTotal === 0"
          (click)="toggleExportMenu()"
          title="Opciones de exportación a Excel">
          <i class="fas fa-file-excel"></i> Exportar a Excel
          <i class="fas" [ngClass]="exportMenuOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </button>
        <div class="export-dropdown-menu" *ngIf="exportMenuOpen">
          <button type="button" (click)="exportOrdersFormatToExcel()">
            <i class="fas fa-list"></i> Excel EXPORT
          </button>
          <button type="button" (click)="exportTableFormatToExcel()">
            <i class="fas fa-table"></i> Excel ESTADISTICAS
          </button>
        </div>
      </div>
      <button (click)="openBulkEditSparePartsModal()" class="change-status-button"
        [disabled]="selectedItems.length === 0 && !isSelectingAllFiltered">
        <i class="fas fa-pen-to-square"></i> Edición Masiva
        <span *ngIf="selectedItems.length > 0 || isSelectingAllFiltered" class="selected-count">
          ({{ selectedCount }})
        </span>
      </button>
      <button (click)="openMultiEditSparePartsModal()" class="change-status-button"
        [disabled]="selectedItems.length === 0 && !isSelectingAllFiltered"
        title="Editar peso líquido, peso bruto, país y grupo de paquete por repuesto">
        <i class="fas fa-cubes"></i> Peso / país y paquetes
        <span *ngIf="selectedItems.length > 0 || isSelectingAllFiltered" class="selected-count">
          ({{ selectedCount }})
        </span>
      </button>
      <button (click)="openAssignExportInfoModal()" class="change-status-button">
        <i class="fas fa-file-signature"></i> Asignar Exportación
      </button>
      <input
        #remitosFileInput
        type="file"
        accept=".xlsx,.xls"
        class="hidden"
        (change)="onRemitosExcelSelected($event)">
      <button
        type="button"
        (click)="triggerRemitosImport(remitosFileInput)"
        class="change-status-button"
        [disabled]="importingRemitosFromExcel"
        title="Importar Excel con columnas id y remito">
        <i class="fas fa-file-import"></i>
        {{ importingRemitosFromExcel ? 'Importando...' : 'Importar remitos (Excel)' }}
      </button>
    </div>

    <!-- Información de filtrado -->
    <div class="filter-info">
      <span>
        Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, filteredTotal) }}
        de {{ filteredTotal }} repuestos
      </span>
      <span *ngIf="totalSparePartsInDB > 0" class="total-info">
        (Total en base de datos: {{ totalSparePartsInDB }} repuestos)
      </span>
      <span *ngIf="loading" class="loading-info">
        Cargando datos...
      </span>
    </div>

  </div>

  <!-- Botón de cargar/actualizar -->
  <div class="flex justify-end mb-4 px-4">
    <button (click)="reloadData()" [disabled]="loading"
      class="bg-blue-500 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-2 px-4 rounded flex items-center gap-2 transition-colors shadow-md">
      <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
      <span>{{ loading ? 'Cargando...' : 'Cargar' }}</span>
    </button>
  </div>

  <!-- Paginación (Movida a la parte superior) -->
  <div class="pagination-container" *ngIf="filteredTotal > 0">
    <div class="pagination-info">
      <span>Página {{ currentPage }} de {{ totalPages }}</span>
    </div>

    <div class="pagination">
      <button [disabled]="currentPage === 1" (click)="goToPage(1)" class="pagination-button" title="Primera página">
        &laquo;
      </button>
      <button [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)" class="pagination-button"
        title="Página anterior">
        &lsaquo;
      </button>

      <!-- Números de página -->
      <div class="page-numbers">
        <button *ngFor="let page of getPageNumbers(); trackBy: trackByIndex" [class.active]="page === currentPage" (click)="goToPage(page)"
          class="page-number-button">
          {{ page }}
        </button>
      </div>

      <button [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)" class="pagination-button"
        title="Página siguiente">
        &rsaquo;
      </button>
      <button [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)" class="pagination-button"
        title="Última página">
        &raquo;
      </button>
    </div>

    <div class="page-size-selector">
      <label for="pageSize">Repuestos por página:</label>
      <select id="pageSize" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="500">500</option>
      </select>
    </div>
  </div>

  <!-- Tabla de repuestos (mismo placeholder que órdenes mientras se esperan resultados) -->
  <div class="table-responsive-container table-fixed-header table-scroll-horizontal spare-main-table-wrapper">
    <div *ngIf="loading" class="table-loading">
      <div class="table-loading-spinner"></div>
      <span class="ml-2">Cargando datos...</span>
    </div>
    <table *ngIf="!loading" class="table-responsive table-mobile-cards table-fade-in spare-main-table">
      <thead>
        <tr>
          <th class="spare-row-index-header" scope="col" title="Número de fila">#</th>
          <th>
            <input type="checkbox" [(ngModel)]="allSelected" (change)="toggleAllSelection()">
          </th>
          <th class="w-8"></th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('clienteUY')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('clienteUY', $event); $event.stopPropagation()">Cliente Uy</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('clienteUY'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'clienteUY'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'clienteUY'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Data Ordem -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('orderDate')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('orderDate', $event); $event.stopPropagation()">Data Ordem</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('orderDate'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'orderDate'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'orderDate'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Emoji (TransportType) -->
          <th class="sortable-header text-center w-12 excel-filter-header" style="cursor: pointer;" [class.column-filter-active]="isSparePartColumnFiltered('transportType')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('transportType', $event); $event.stopPropagation()" title="Filtrar por vehículo">🚚</span>
              <i class="fas fa-sort sort-icon" (click)="sortTransportType($event); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'transportType'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'transportType'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Carregamento -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('carregamento')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('carregamento', $event); $event.stopPropagation()">Carga</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('transportType'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'transportType'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'transportType'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Num EXP -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('exportNumber')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('exportNumber', $event); $event.stopPropagation()">Num EXP</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('exportNumber'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'exportNumber'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'exportNumber'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Fecha Exportación -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('fechaExportacion')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('fechaExportacion', $event); $event.stopPropagation()">F. Exp.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('fechaExportacion'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'fechaExportacion'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'fechaExportacion'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Dias de atraso -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('diasAtraso')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('diasAtraso', $event); $event.stopPropagation()">D. Atr.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('diasAtraso'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'diasAtraso'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'diasAtraso'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Dias Prazo (orden: emisión → llegada esperada orden; mismo valor por fila que en lógica de repuesto) -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('diasPrazo')"
            title="Días entre emisión de la orden (Data Ordem) y F. Esp. de este repuesto">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('diasPrazo', $event); $event.stopPropagation()">D. Pzo.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('diasPrazo'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'diasPrazo'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'diasPrazo'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Ordem -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('orderNumber')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('orderNumber', $event); $event.stopPropagation()">Ordem</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('orderNumber'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'orderNumber'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'orderNumber'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Sinistro -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('siniestro')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('siniestro', $event); $event.stopPropagation()">Sinistro</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('siniestro'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'siniestro'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'siniestro'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Nome Port -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('sparePartName')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('sparePartName', $event); $event.stopPropagation()">Nombre</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('sparePartName'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'sparePartName'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'sparePartName'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Código Peça -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('productCode')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('productCode', $event); $event.stopPropagation()">Cód. Peça</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('productCode'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'productCode'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'productCode'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Quant -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('amount')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('amount', $event); $event.stopPropagation()">Quant</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('amount'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'amount'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'amount'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Preço Unit (R$) -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('unitPrice')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('unitPrice', $event); $event.stopPropagation()">P. Unit</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('unitPrice'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'unitPrice'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'unitPrice'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Valor Venda ($) -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('valorDeVenta')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('valorDeVenta', $event); $event.stopPropagation()">V. Vend</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('valorDeVenta'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'valorDeVenta'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'valorDeVenta'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Peso Neto -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('netWheight')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('netWheight', $event); $event.stopPropagation()">P. Neto</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('netWheight'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'netWheight'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'netWheight'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Peso Bruto -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('grossWheight')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('grossWheight', $event); $event.stopPropagation()">P. Bruto</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('grossWheight'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'grossWheight'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'grossWheight'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Estado -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('productStatus')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('productStatus', $event); $event.stopPropagation()">Estado</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('productStatus'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'productStatus'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'productStatus'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Exportado en -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('lastExportedAt')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('lastExportedAt', $event); $event.stopPropagation()">Exp. en</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('lastExportedAt'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'lastExportedAt'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'lastExportedAt'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Estado Envio -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('shippingStatus')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('shippingStatus', $event); $event.stopPropagation()">E. Envío</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('shippingStatus'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'shippingStatus'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'shippingStatus'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Recepción -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('receptionStatus')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('receptionStatus', $event); $event.stopPropagation()">Recepción</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('receptionStatus'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'receptionStatus'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'receptionStatus'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('arrivalDate')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('arrivalDate', $event); $event.stopPropagation()">Fecha de llegada</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('arrivalDate'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'arrivalDate'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'arrivalDate'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('packager')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('packager', $event); $event.stopPropagation()">Empaquetador</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('packager'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'packager'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'packager'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('returnStatus')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('returnStatus', $event); $event.stopPropagation()">E. Dev.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('returnStatus'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'returnStatus'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'returnStatus'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('returnLogStatus')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('returnLogStatus', $event); $event.stopPropagation()">E. Dev LOG</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('returnLogStatus'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'returnLogStatus'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'returnLogStatus'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('returnReason')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('returnReason', $event); $event.stopPropagation()">Mot. Dev.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('returnReason'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'returnReason'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'returnReason'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('returnCarrier')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('returnCarrier', $event); $event.stopPropagation()">Transp.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('returnCarrier'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'returnCarrier'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'returnCarrier'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('nfd')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('nfd', $event); $event.stopPropagation()">NFD</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('nfd'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'nfd'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'nfd'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('mlStatus')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('mlStatus', $event); $event.stopPropagation()">Sit. ML</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('mlStatus'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'mlStatus'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'mlStatus'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('mlDeadline')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('mlDeadline', $event); $event.stopPropagation()">Prazo ML</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('mlDeadline'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'mlDeadline'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'mlDeadline'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('freteDev')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('freteDev', $event); $event.stopPropagation()">FRETE DEV</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('freteDev'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'freteDev'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'freteDev'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('returnDetails')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('returnDetails', $event); $event.stopPropagation()">Det. Adic.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('returnDetails'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'returnDetails'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'returnDetails'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Data Esperada -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('expectedArrivalDate')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('expectedArrivalDate', $event); $event.stopPropagation()">F. Esp.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('expectedArrivalDate'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'expectedArrivalDate'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'expectedArrivalDate'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Comentários -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('comments')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('comments', $event); $event.stopPropagation()">Comentários</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('comments'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'comments'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'comments'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('emergentComment')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('emergentComment', $event); $event.stopPropagation()">Comentario emergente</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('emergentComment'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'emergentComment'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'emergentComment'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('interno')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('interno', $event); $event.stopPropagation()">Interno</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('interno'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'interno'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'interno'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('externo')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('externo', $event); $event.stopPropagation()">Externo</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('externo'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'externo'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'externo'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('fechaDeComunicado')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('fechaDeComunicado', $event); $event.stopPropagation()">F. Com.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('fechaDeComunicado'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'fechaDeComunicado'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'fechaDeComunicado'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('color')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('color', $event); $event.stopPropagation()">Color</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('color'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'color'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'color'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Vendedor -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('vendedor')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('vendedor', $event); $event.stopPropagation()">Vendedor</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('vendedor'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'vendedor'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'vendedor'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Fornecedor -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('fornecedor')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('fornecedor', $event); $event.stopPropagation()">Fornecedor</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('fornecedor'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'fornecedor'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'fornecedor'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Cod BR -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('codBr')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('codBr', $event); $event.stopPropagation()">Cod BR</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('codBr'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'codBr'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'codBr'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Nota Fiscal -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('taxNote')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('taxNote', $event); $event.stopPropagation()">Nota Fiscal</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('taxNote'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'taxNote'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'taxNote'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- NCM -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('ncm')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('ncm', $event); $event.stopPropagation()">NCM</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('ncm'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'ncm'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'ncm'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- País -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('country')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('country', $event); $event.stopPropagation()">País</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('country'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'country'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'country'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Num Pacote -->
          <th class="sortable-header excel-filter-header spare-col-n-pqt" [class.column-filter-active]="isSparePartColumnFiltered('packageNumber')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('packageNumber', $event); $event.stopPropagation()">N. Pqt.</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('packageNumber'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'packageNumber'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'packageNumber'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Está dañado -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('isDamaged')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('isDamaged', $event); $event.stopPropagation()">Está dañado</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('isDamaged'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'isDamaged'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'isDamaged'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Need Review -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('needReview')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('needReview', $event); $event.stopPropagation()">Need Review</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('needReview'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'needReview'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'needReview'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- FANT? -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('isFant')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('isFant', $event); $event.stopPropagation()">FANT?</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('isFant'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'isFant'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'isFant'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Urgencia FANT -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('fantUrgency')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('fantUrgency', $event); $event.stopPropagation()">Urgencia FANT</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('fantUrgency'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'fantUrgency'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'fantUrgency'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Recompra -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('recompra')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('recompra', $event); $event.stopPropagation()">Recompra</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('recompra'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'recompra'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'recompra'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Control -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('control')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('control', $event); $event.stopPropagation()">Control</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('control'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'control'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'control'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Anulado -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('anulado')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('anulado', $event); $event.stopPropagation()">Anulado</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('anulado'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'anulado'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'anulado'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Trello -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('trello')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('trello', $event); $event.stopPropagation()">Trello</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('trello'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'trello'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'trello'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- DevZureo -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('devZureo')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('devZureo', $event); $event.stopPropagation()">DevZureo</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('devZureo'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'devZureo'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'devZureo'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Entrada Sage -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('entradaSage')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('entradaSage', $event); $event.stopPropagation()">Entrada Sage</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('entradaSage'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'entradaSage'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'entradaSage'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Controle Seba -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('controleSeba')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('controleSeba', $event); $event.stopPropagation()">Controle Seba</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('controleSeba'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'controleSeba'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'controleSeba'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Ok Anulação -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('okAnulacao')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('okAnulacao', $event); $event.stopPropagation()">Ok Anulação</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('okAnulacao'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'okAnulacao'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'okAnulacao'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Facturado -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('facturado')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('facturado', $event); $event.stopPropagation()">Facturado</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('facturado'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'facturado'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'facturado'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <!-- Taller -->
          <th class="sortable-header excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('workshopName')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('workshopName', $event); $event.stopPropagation()">Taller</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('workshopName'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'workshopName'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'workshopName'" class="sort-indicator">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </div>
          </th>
          <th class="excel-filter-header" [class.column-filter-active]="isSparePartColumnFiltered('sendYesOrNo')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="openFilterMenu('sendYesOrNo', $event); $event.stopPropagation()">Enviar</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sparePart of displayedSpareParts; let rowIndex = index; trackBy: trackBySparePartId" (click)="sparePartModal(sparePart); $event.stopPropagation()"
          [ngClass]="[
            'cursor-pointer',
            getSparePartRowClass(sparePart),
            sparePart['selected'] ? 'selected' : '',
            sparePart.sparePartId === lastEditedSparePartId ? 'last-edited-row' : '',
            sparePart.sparePartId === activeFocusedRowId ? 'active-focused-row' : ''
          ]">
          <td class="spare-row-index-cell" data-label="#">{{ sparePart.sparePartId ?? '-' }}</td>
          <td (click)="$event.stopPropagation()">
            <div class="flex items-center gap-2">
              <input type="checkbox" [(ngModel)]="sparePart['selected']" (change)="toggleSelection(sparePart)">
              <button type="button" class="text-indigo-600 hover:text-indigo-800 text-xs"
                title="Duplicar repuesto" (click)="duplicateSparePartWithChanges(sparePart); $event.stopPropagation()">
                <i class="fas fa-clone"></i>
              </button>
            </div>
          </td>
          <td class="text-center" [ngClass]="getDelayCellClass(sparePart)" (click)="$event.stopPropagation()">
            <i *ngIf="hasDelayAlert(sparePart)"
              class="fas fa-exclamation-triangle cursor-pointer"
              [ngClass]="getDelayIconClass(sparePart)"
              title="Atraso detectado. Haz clic para ocultar esta alerta en esta sesión."
              (click)="dismissDelayAlert($event, sparePart)"
              (keyup.enter)="dismissDelayAlert($event, sparePart)"
              tabindex="0"></i>
          </td>
          <td data-label="Cliente Uy">{{ sparePart.clienteUY || '—' }}</td>
          <!-- Data Ordem -->
          <td data-label="Data Ordem">{{ sparePart.orderDate | date:'dd/MM/yyyy' }}</td>
          <!-- Emoji (TransportType) -->
          <td data-label="Emoji" class="text-center" [title]="getTransportText(sparePart)">
            <span *ngIf="isSparePartLoaded(sparePart)" class="text-lg" [innerHTML]="getTransportIcon(sparePart)">
            </span>
          </td>
          <!-- Carregamento -->
          <td data-label="Carregamento">{{ getTransportText(sparePart) }}</td>
          <!-- Num EXP -->
          <td data-label="Num EXP">
            <span *ngIf="sparePart.exportNumber && sparePart.exportNumber !== ''"
              class="export-number bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm">
              {{ sparePart.exportNumber }}
            </span>
            <span *ngIf="!sparePart.exportNumber || sparePart.exportNumber === ''"
              class="missing-export-number text-gray-400 text-sm">
              -
            </span>
          </td>
          <!-- Fecha Exportación -->
          <td data-label="Fecha Exportación">
            <span *ngIf="sparePart.fechaExportacion">{{ sparePart.fechaExportacion | date:'dd/MM/yyyy' }}</span>
            <span *ngIf="!sparePart.fechaExportacion" class="text-gray-400">—</span>
          </td>
          <!-- Dias de atraso -->
          <td data-label="Dias de atraso">
            {{ getDelayDays(sparePart) }}
          </td>
          <!-- Dias Prazo -->
          <td data-label="Dias Prazo" [class.low-sale-ratio-cell]="isLowSaleRatioRow(sparePart)">{{ formatDiasPrazo(sparePart) }}</td>
          <!-- Ordem -->
          <td data-label="Ordem" [class.low-sale-ratio-cell]="isLowSaleRatioRow(sparePart)">
            <span *ngIf="sparePart.orderNumber && sparePart.orderNumber !== ''" class="order-number">
              {{ sparePart.orderNumber }}
            </span>
            <span *ngIf="!sparePart.orderNumber || sparePart.orderNumber === ''" class="missing-order-number">
              -
            </span>
          </td>
          <!-- Sinistro -->
          <td data-label="Sinistro" [class.low-sale-ratio-cell]="isLowSaleRatioRow(sparePart)">{{ sparePart.siniestro || '-' }}</td>
          <!-- Nome Port -->
          <td data-label="Nome Port">{{ sparePart.sparePartName }}</td>
          <!-- Código Peça -->
          <td data-label="Código Peça">{{ sparePart.productCode }}</td>
          <!-- Quant -->
          <td data-label="Quant">{{ sparePart.amount }}</td>
          <!-- Preço Unit (R$) -->
          <td data-label="Preço Unit (R$)" [class.low-sale-ratio-cell]="isLowSaleRatioRow(sparePart)">{{ sparePart.unitPrice | currency:'BRL':'symbol':'1.2-2' }}</td>
          <!-- Valor Venda ($) -->
          <td data-label="Valor Venda ($)" [class.low-sale-ratio-cell]="isLowSaleRatioRow(sparePart)">$ {{ sparePart.valorDeVenta | number:'1.2-2' }}</td>
          <!-- Peso Neto -->
          <td data-label="Peso Neto">{{ sparePart.netWheight ?? '-' }}</td>
          <!-- Peso Bruto -->
          <td data-label="Peso Bruto">{{ sparePart.grossWheight ?? '-' }}</td>
          <!-- Estado -->
          <td data-label="Estado">
            <span class="status-badge" [ngClass]="getStatusClass(sparePart.productStatus)">
              {{ sparePart.productStatus }}
            </span>
          </td>
          <!-- Exportado en -->
          <td data-label="Exportado en">
            <span *ngIf="sparePart.lastExportedAt">{{ sparePart.lastExportedAt | date:'dd/MM/yyyy HH:mm' }}</span>
            <span *ngIf="!sparePart.lastExportedAt" class="text-gray-400">—</span>
          </td>
          <!-- Estado Envio -->
          <td data-label="Estado Envio">
            <span class="status-badge" [ngClass]="getShippingStatusClass(sparePart.shippingStatus)">
              {{ sparePart.shippingStatus || 'No definido' }}
            </span>
          </td>
          <!-- Recepción -->
          <td data-label="Recepción">
            <span class="reception-status-badge"
              [ngClass]="getReceptionStatusFieldClass(sparePart.receptionStatus)">
              {{ getReceptionDisplayValue(sparePart) }}
            </span>
          </td>
          <td data-label="Fecha de llegada">
            <span *ngIf="sparePart.arrivalDate">{{ formatArrivalDateTime(sparePart.arrivalDate) }}</span>
            <span *ngIf="!sparePart.arrivalDate" class="text-gray-400">—</span>
          </td>
          <td data-label="Empaquetador">{{ sparePart.packager || '—' }}</td>
          <td data-label="Estado devolución">{{ sparePart.returnStatus || '-' }}</td>
          <td data-label="Estado devolución LOG">{{ sparePart.returnLogStatus || '-' }}</td>
          <td data-label="Motivo devolución">{{ sparePart.returnReason || '-' }}</td>
          <td data-label="Transportadoras">{{ sparePart.returnCarrier || '-' }}</td>
          <td data-label="NFD">{{ sparePart.nfd || '-' }}</td>
          <td data-label="Situación ML">{{ sparePart.mlStatus || '-' }}</td>
          <td data-label="Prazo ML">
            <span *ngIf="sparePart.mlDeadline">{{ sparePart.mlDeadline | date:'dd/MM/yyyy' }}</span>
            <span *ngIf="!sparePart.mlDeadline">-</span>
          </td>
          <td data-label="FRETE DEV">{{ sparePart.freteDev || '-' }}</td>
          <td data-label="Detalles Adicionales">{{ sparePart.returnDetails || '-' }}</td>
          <!-- Data Esperada -->
          <td data-label="Data Esperada">{{ sparePart.expectedArrivalDate | date:'dd/MM/yyyy' }}</td>
          <!-- Comentários -->
          <td data-label="Comentários">{{ sparePart.comments || '-' }}</td>
          <td data-label="Comentario emergente" [title]="getEmergentCommentDisplay(sparePart)">
            {{ getEmergentCommentDisplay(sparePart) || '-' }}
          </td>
          <td data-label="Interno">{{ sparePart.interno || '-' }}</td>
          <td data-label="Externo">{{ sparePart.externo || '-' }}</td>
          <td data-label="Fecha Comunicado">{{ sparePart.fechaDeComunicado ? (sparePart.fechaDeComunicado | date:'dd/MM/yyyy') : '-' }}</td>
          <td data-label="Color">
            <span *ngIf="sparePart.color"
              class="inline-block w-5 h-5 border rounded align-middle mr-1"
              [title]="sparePart.color"
              [ngStyle]="{ 'background-color': getAldanaColorHex(sparePart.color) }"></span>
            <span>{{ sparePart.color || '-' }}</span>
          </td>
          <!-- Vendedor -->
          <td data-label="Vendedor">{{ sparePart.vendedor || '-' }}</td>
          <!-- Fornecedor -->
          <td data-label="Fornecedor">{{ sparePart.fornecedor || '-' }}</td>
          <!-- Cod BR -->
          <td data-label="Cod BR">{{ sparePart.codBr || '-' }}</td>
          <!-- Nota Fiscal -->
          <td data-label="Nota Fiscal">{{ sparePart.taxNote || '-' }}</td>
          <!-- NCM -->
          <td data-label="NCM">{{ sparePart.ncm || '-' }}</td>
          <!-- País -->
          <td data-label="País">{{ sparePart.country || '-' }}</td>
          <!-- Num Pacote -->
          <td class="spare-col-n-pqt" data-label="Num Pacote">{{ sparePart.packageNumber || '-' }}</td>
          <!-- Está dañado -->
          <td data-label="Está dañado">{{ sparePart.isDamaged || '-' }}</td>
          <!-- Need Review -->
          <td data-label="Need Review">{{ isNeedReview(sparePart) ? 'SI' : 'NO' }}</td>
          <!-- FANT? -->
          <td data-label="FANT?" (click)="$event.stopPropagation()">
            <input type="checkbox"
                   [checked]="sparePart.isFant"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.isFant = $event.target.checked; onFantToggled(sparePart)">
          </td>
          <!-- Urgencia FANT -->
          <td data-label="Urgencia FANT" (click)="$event.stopPropagation()">
            <span *ngIf="!isFantChecked(sparePart)">-</span>
            <select *ngIf="isFantChecked(sparePart)"
                    class="fant-urgency-picker"
                    [class.fant-urgency-green]="getFantUrgency(sparePart) === 'green'"
                    [class.fant-urgency-yellow]="getFantUrgency(sparePart) === 'yellow'"
                    [class.fant-urgency-red]="getFantUrgency(sparePart) === 'red'"
                    [class.fant-urgency-empty]="!getFantUrgency(sparePart)"
                    [attr.title]="getFantUrgencyLabel(sparePart) || 'Sin color'"
                    [ngModel]="getFantUrgency(sparePart) || ''"
                    (ngModelChange)="setTableFantUrgency(sparePart, $event)"
                    (click)="$event.stopPropagation()">
              <option value="">-</option>
              <option value="green">Verde</option>
              <option value="yellow">Amarillo</option>
              <option value="red">Rojo</option>
            </select>
          </td>
          <!-- Recompra -->
          <td data-label="Recompra">
            <input type="checkbox"
                   [checked]="isRecompra(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.recompra = $event.target.checked; onRecompraToggled(sparePart)">
          </td>
          <!-- Control -->
          <td data-label="Control">
            <input type="checkbox"
                   [checked]="isControl(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.control = $event.target.checked; onControlToggled(sparePart)">
          </td>
          <!-- Anulado -->
          <td data-label="Anulado">
            <input type="checkbox"
                   [checked]="isAnulado(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.anulado = $event.target.checked; onAnuladoToggled(sparePart)">
          </td>
          <!-- Trello -->
          <td data-label="Trello">
            <input type="checkbox"
                   [checked]="isTrello(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.trello = $event.target.checked; onTrelloToggled(sparePart)">
          </td>
          <!-- DevZureo -->
          <td data-label="DevZureo">
            <input type="checkbox"
                   [checked]="isDevZureo(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.devZureo = $event.target.checked; onDevZureoToggled(sparePart)">
          </td>
          <!-- Entrada Sage -->
          <td data-label="Entrada Sage">
            <input type="checkbox"
                   [checked]="isEntradaSage(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.entradaSage = $event.target.checked; onEntradaSageToggled(sparePart)">
          </td>
          <!-- Controle Seba -->
          <td data-label="Controle Seba">
            <input type="checkbox"
                   [checked]="isControleSeba(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.controleSeba = $event.target.checked; onControleSebaToggled(sparePart)">
          </td>
          <!-- Ok Anulação -->
          <td data-label="Ok Anulação">
            <input type="checkbox"
                   [checked]="isOkAnulacao(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.okAnulacao = $event.target.checked; onOkAnulacaoToggled(sparePart)">
          </td>
          <!-- Facturado -->
          <td data-label="Facturado">
            <input type="checkbox"
                   [checked]="isFacturado(sparePart)"
                   (click)="$event.stopPropagation()"
                   (change)="sparePart.facturado = $event.target.checked; onFacturadoToggled(sparePart)">
          </td>
          <td data-label="Taller">{{ sparePart.workshopName || '-' }}</td>
          <td data-label="Enviar">{{ sparePart.sendYesOrNo === 'true' ? 'SI' : 'NO' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Panel de resumen de repuestos desplegado -->
  <div class="summary-panel" *ngIf="!loading && displayedSpareParts.length > 0">
    <h3 class="summary-title">
      Resumen de repuestos filtrados
    </h3>
    <div class="summary-grid">
      <div class="summary-item">
        <span class="summary-label">Costo total de repuestos filtrados:</span>
        <span class="summary-value">{{ totalCost | currency }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Valor de venta total de repuestos filtrados:</span>
        <span class="summary-value">{{ totalSalesValue | currency }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Cantidad total de repuestos filtrados:</span>
        <span class="summary-value">{{ filteredTotal }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Repuestos anulados (en filtro actual):</span>
        <span class="summary-value">{{ getFilteredAnnulledSparePartsCount() }}</span>
      </div>
    </div>
    <div class="filter-indication" *ngIf="hasAppliedFiltersForSummary()">
      <div class="filter-badge">
        <i class="fas fa-filter"></i> Filtros aplicados:
        <span class="filter-term">{{ getAppliedFiltersSummary() }}</span>
      </div>
    </div>
  </div>

  <!-- Indicador de carga de más elementos -->
  <div class="load-more-indicator" *ngIf="isLoadingMore">
    <div class="spinner-small"></div>
    <span>Cargando más repuestos...</span>
  </div>

  <!-- No results message -->
  <div class="no-results" *ngIf="!loading && filteredSpareParts.length === 0">
    No se encontraron repuestos que coincidan con los criterios de búsqueda
  </div>

  <!-- Estilos -->
  <style>
    .filters-container {
      margin-bottom: 20px;
      padding: 15px;
      background: #f5f5f5;
      border-radius: 8px;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .search-container {
      display: flex;
      gap: 10px;
      margin-bottom: 10px;
    }

    .search-input {
      flex: 1;
      padding: 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    .reload-button {
      padding: 8px 15px;
      background: #4CAF50;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .reload-button:disabled {
      background: #cccccc;
      cursor: not-allowed;
    }

    .export-button {
      padding: 8px 15px;
      background: #28a745;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .export-button:hover:not(:disabled) {
      background: #218838;
    }

    .export-button:disabled {
      background: #cccccc;
      cursor: not-allowed;
    }

    .export-dropdown {
      position: relative;
      display: inline-block;
    }

    .export-dropdown-menu {
      position: absolute;
      top: calc(100% + 6px);
      right: 0;
      min-width: 230px;
      background: white;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
      z-index: 100;
      overflow: hidden;
    }

    .export-dropdown-menu button {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 12px;
      border: none;
      background: white;
      color: #111827;
      cursor: pointer;
      text-align: left;
      font-size: 0.9rem;
    }

    .export-dropdown-menu button:hover {
      background: #f3f4f6;
    }

    .change-status-button {
      padding: 8px 15px;
      background: #3498db;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .change-status-button:hover:not(:disabled) {
      background: #2980b9;
    }

    .change-status-button:disabled {
      background: #cccccc;
      cursor: not-allowed;
    }

    .selected-count {
      background-color: #2c3e50;
      color: white;
      border-radius: 12px;
      padding: 0 8px;
      margin-left: 8px;
      font-size: 0.85em;
      display: inline-block;
    }

    .filter-info {
      font-size: 0.9em;
      color: #666;
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
    }

    .loading-info {
      color: #3498db;
      font-weight: bold;
    }

    .total-info {
      color: #e67e22;
      margin-left: 8px;
      font-style: italic;
    }

    .db-info {
      color: #e67e22;
      margin-left: 8px;
      font-style: italic;
      font-size: 0.9em;
    }

    .loading-spinner {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      padding: 20px;
    }

    .spinner {
      width: 30px;
      height: 30px;
      border: 3px solid #f3f3f3;
      border-top: 3px solid #3498db;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    .spinner-small {
      width: 20px;
      height: 20px;
      border: 2px solid #f3f3f3;
      border-top: 2px solid #3498db;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }

    .table-container {
      height: calc(100vh - 400px);
      overflow-y: auto;
      overflow-x: auto;
      border: 1px solid #ddd;
      border-radius: 4px;
      position: relative;
      margin-top: 10px;
    }

    /* Contenedor responsivo con altura completa */
    .table-responsive-container {
      max-height: calc(100vh - 260px);
      overflow-y: auto;
      overflow-x: auto;
      border: 1px solid #ddd;
      border-radius: 4px;
      margin-bottom: 12px;
      width: 100%;
    }

    .table-fixed-header {
      position: relative;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }

    .spare-main-table-wrapper {
      width: 100%;
    }

    .spare-main-table {
      min-width: 2600px;
      table-layout: auto;
    }

    thead {
      position: sticky;
      top: 0;
      z-index: 5;
      background-color: #f8f9fa;
    }

    th,
    td {
      padding: 7px 10px;
      text-align: left;
      border-bottom: 1px solid #ddd;
      font-size: 0.84rem;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    th {
      background-color: #f8f9fa;
      font-weight: 600;
    }

    .spare-main-table thead th {
      font-weight: 800;
      font-size: clamp(0.82rem, 0.78rem + 0.2vw, 0.96rem);
      color: #111827;
      background: #eef2f7;
      border-bottom: 2px solid #cbd5e1;
      letter-spacing: 0.01em;
    }

    tr:hover {
      background-color: #f5f5f5;
    }

    .selected-row {
      background-color: #e6f7ff !important;
    }

    .no-results {
      text-align: center;
      padding: 20px;
      color: #666;
    }

    /* Fila de repuesto marcado como FANT */
    .fant-row {
      background-color: #f3e8ff;
    }

    .fant-row:hover {
      background-color: #e9d5ff;
    }

    .anulado-row {
      background-color: #fecaca;
    }

    .anulado-row:hover {
      background-color: #fca5a5;
    }

    .fant-urgency-picker {
      width: 1.15rem;
      height: 1.15rem;
      border-radius: 999px;
      border: 2px solid #111827;
      appearance: none;
      -webkit-appearance: none;
      cursor: pointer;
      color: transparent;
      font-size: 0;
      padding: 0;
      vertical-align: middle;
    }

    .fant-urgency-picker option {
      color: #111827;
      font-size: 0.85rem;
    }

    .fant-urgency-green { background-color: #22c55e; }
    .fant-urgency-yellow { background-color: #facc15; }
    .fant-urgency-red { background-color: #ef4444; }
    .fant-urgency-empty {
      background-color: #fff;
      border-color: #d1d5db;
    }

    .date-filters {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .custom-date-range {
      display: flex;
      gap: 10px;
    }

    select,
    input[type="date"] {
      padding: 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    /* Estilos para el selector de estados */
    .status-filter {
      display: flex;
      align-items: center;
    }

    .status-select {
      padding: 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background-color: white;
      min-width: 200px;
    }

    .status-select option {
      padding: 4px;
    }

    .load-more-indicator {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      padding: 15px;
      background-color: #f8f9fa;
    }

    .pagination-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      margin-bottom: 20px;
      background-color: #f8f9fa;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    .pagination-info {
      font-size: 0.9em;
      color: #666;
    }

    .pagination {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .pagination-button {
      padding: 8px 12px;
      background: #3498db;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      min-width: 40px;
      text-align: center;
    }

    .pagination-button:hover:not(:disabled) {
      background: #2980b9;
    }

    .pagination-button:disabled {
      background: #cccccc;
      cursor: not-allowed;
    }

    .page-numbers {
      display: flex;
      gap: 5px;
    }

    .page-number-button {
      padding: 8px 12px;
      background: #f8f9fa;
      color: #333;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      min-width: 40px;
      text-align: center;
    }

    .page-number-button:hover {
      background: #e9ecef;
    }

    .page-number-button.active {
      background: #3498db;
      color: white;
      border-color: #3498db;
    }

    .page-size-selector {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .page-size-selector select {
      padding: 6px;
      border-radius: 4px;
      border: 1px solid #ddd;
    }

    /* Estilos para ordenación */
    .sortable-header {
      cursor: pointer;
      user-select: none;
      position: relative;
      padding-right: 18px;
      /* Espacio para el indicador de ordenación */
    }

    .sortable-header:hover {
      background-color: #f0f0f0;
    }

    .sort-indicator {
      display: inline-block;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
    }

    /* Estilos para el panel de resumen */
    .summary-panel {
      margin-top: 20px;
      padding: 15px;
      background: #f5f5f5;
      border: 1px solid #ddd;
      border-radius: 8px;
    }

    .summary-title {
      font-size: 1.2em;
      font-weight: bold;
      margin-bottom: 15px;
      color: #2c3e50;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .filtered-count {
      font-size: 0.85em;
      font-weight: normal;
      color: #7f8c8d;
      margin-left: 10px;
    }

    .summary-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 20px;
    }

    .summary-item {
      display: flex;
      flex-direction: column;
    }

    .summary-label {
      font-weight: 600;
      color: #7f8c8d;
      margin-bottom: 5px;
    }

    .summary-value {
      font-size: 1.1em;
      font-weight: bold;
      color: #2c3e50;
    }

    /* Estilo para fila de resumen en tabla */
    .summary-row {
      background-color: #f0f8ff;
      font-weight: bold;
    }

    .summary-row td {
      border-top: 2px solid #3498db;
    }

    /* Estilos para indicación de filtros */
    .filter-indication {
      margin-top: 15px;
      padding-top: 10px;
      border-top: 1px dashed #ccc;
    }

    .filter-badge {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
      font-size: 0.9em;
      color: #7f8c8d;
    }

    .filter-term {
      display: inline-block;
      background-color: #e1f5fe;
      color: #0288d1;
      padding: 3px 10px;
      border-radius: 12px;
      font-size: 0.85em;
      margin-right: 5px;
    }

    /* Estilo para el repuesto recién editado */
    .last-edited-row {
      animation: highlight-fade 3s ease-out;
    }

    @keyframes highlight-fade {
      0% {
        background-color: #ffeb3b;
      }

      100% {
        background-color: transparent;
      }
    }

    /* Estilos específicos para estado de envío */
    .status-badge.no-sent {
      background-color: #fee2e2;
      color: #dc2626;
      border: 1px solid #fca5a5;
    }

    .status-badge.no-status {
      background-color: #f3f4f6;
      color: #6b7280;
      border: 1px solid #d1d5db;
    }

    .status-badge.completed {
      background-color: #d1fae5;
      color: #065f46;
      border: 1px solid #86efac;
    }

    .status-badge.processing {
      background-color: #fef3c7;
      color: #92400e;
      border: 1px solid #fde68a;
    }

    .status-badge.cancelled {
      background-color: #fee2e2;
      color: #991b1b;
      border: 1px solid #fca5a5;
    }

    /* Estilos para filtros estilo Excel */
    .excel-filter-header {
      position: relative;
    }

    .sortable-header.column-filter-active {
      background-color: #dbeafe !important;
      box-shadow: inset 0 -2px 0 #2563eb;
    }

    .sortable-header.column-filter-active .header-label,
    .sortable-header.column-filter-active .sort-icon,
    .sortable-header.column-filter-active .sort-indicator {
      color: #1d4ed8;
    }

    .header-content {
      display: flex;
      align-items: center;
      gap: 5px;
      min-width: 0;
    }

    .spare-main-table .header-label {
      min-width: 0;
      max-width: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 800;
      text-transform: none;
    }

    .spare-main-table th:nth-child(5),
    .spare-main-table td[data-label="Data Ordem"] { width: 11ch; max-width: 11ch; }

    .spare-main-table th:nth-child(9),
    .spare-main-table td[data-label="Fecha Exportación"] { width: 11ch; max-width: 11ch; }

    .spare-main-table th:nth-child(10),
    .spare-main-table td[data-label="Dias de atraso"] { width: 6ch; max-width: 6ch; text-align: right; }

    .spare-main-table th:nth-child(16),
    .spare-main-table td[data-label="Quant"] { width: 6ch; max-width: 6ch; text-align: right; }

    .spare-main-table th:nth-child(17),
    .spare-main-table td[data-label="Preço Unit (R$)"] { width: 9ch; max-width: 9ch; text-align: right; }

    .spare-main-table th:nth-child(18),
    .spare-main-table td[data-label="Valor Venda ($)"] { width: 9ch; max-width: 9ch; text-align: right; }

    .spare-main-table th:nth-child(22),
    .spare-main-table td[data-label="Exportado en"] { width: 11ch; max-width: 11ch; }

    .spare-main-table th:nth-child(24),
    .spare-main-table td[data-label="Recepción"] { width: 11ch; max-width: 11ch; }

    .spare-main-table th:nth-child(11),
    .spare-main-table td[data-label="Dias Prazo"] { width: 6ch; max-width: 6ch; text-align: right; }

    .spare-main-table th:nth-child(30),
    .spare-main-table td[data-label="Data Esperada"] { width: 11ch; max-width: 11ch; }

    .spare-main-table th:nth-child(34),
    .spare-main-table td[data-label="Fecha Comunicado"] { width: 11ch; max-width: 11ch; }

    .spare-main-table th:nth-child(42),
    .spare-main-table td[data-label="Num Pacote"] { width: 6ch; max-width: 6ch; text-align: right; }

    .spare-main-table th:nth-child(26),
    .spare-main-table td[data-label="Empaquetador"] { width: 14ch; max-width: 14ch; }

    .spare-main-table th:nth-child(25),
    .spare-main-table td[data-label="Fecha de llegada"] { width: 14ch; max-width: 14ch; }

    .sort-icon {
      font-size: 0.8em;
      color: #666;
      cursor: pointer;
      padding: 2px;
    }

    .sort-icon:hover {
      color: #3498db;
    }

    .delay-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 2.5rem;
      padding: 2px 8px;
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 700;
      border: 1px solid transparent;
    }

    .delay-yellow {
      background: #fef9c3;
      color: #854d0e;
      border-color: #facc15;
    }

    .delay-orange {
      background: #ffedd5;
      color: #9a3412;
      border-color: #fb923c;
    }

    .delay-red {
      background: #fee2e2;
      color: #991b1b;
      border-color: #f87171;
    }

    .low-sale-ratio-cell {
      color: #b91c1c;
      font-weight: 600;
    }

    .excel-filter-menu {
      position: fixed;
      background: white;
      border: 1px solid #ddd;
      border-radius: 4px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      min-width: 250px;
      max-width: 350px;
      max-height: 400px;
      display: flex;
      flex-direction: column;
    }

    .filter-menu-header {
      padding: 10px;
      border-bottom: 1px solid #ddd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f8f9fa;
      font-weight: bold;
    }

    .close-filter-btn {
      background: none;
      border: none;
      font-size: 1.5em;
      cursor: pointer;
      color: #666;
      padding: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .close-filter-btn:hover {
      color: #e74c3c;
    }

    .filter-menu-content {
      padding: 10px;
      overflow-y: auto;
      flex: 1;
    }

    .filter-search {
      margin-bottom: 10px;
    }

    .filter-search input {
      width: 100%;
      padding: 6px;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    .filter-options {
      max-height: 250px;
      overflow-y: auto;
    }

    .filter-option {
      display: flex;
      align-items: center;
      padding: 5px;
      cursor: pointer;
    }

    .filter-option:hover {
      background: #f0f0f0;
    }

    .filter-option input[type="checkbox"] {
      margin-right: 8px;
    }

    .filter-input {
      width: 100%;
      padding: 6px;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    .filter-menu-footer {
      padding: 10px;
      border-top: 1px solid #ddd;
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }

    .clear-filter-btn,
    .apply-filter-btn {
      padding: 6px 12px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 0.9em;
    }

    .clear-filter-btn {
      background: #e74c3c;
      color: white;
    }

    .clear-filter-btn:hover {
      background: #c0392b;
    }

    .apply-filter-btn {
      background: #3498db;
      color: white;
    }

    .apply-filter-btn:hover {
      background: #2980b9;
    }
  </style>

  <!-- Spare Part Modal -->
  <app-spare-part-modal *ngIf="openSparePartModal" [selectedSparePart]="selectedSparePart"
    [duplicateMode]="isDuplicatingSparePart" [duplicateTargetOrderNumber]="duplicateSparePartTargetOrderNumber"
    (duplicateTargetOrderNumberChange)="duplicateSparePartTargetOrderNumber = $event" (close)="closeSparePartModal()"
    (sparePartUpdated)="onSparePartUpdated($event)" (duplicateRequested)="duplicateSparePartWithChanges($event)">
  </app-spare-part-modal>

  <!-- Modal edición masiva -->
  <div *ngIf="openBulkEditModal" class="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-2xl p-5" (click)="$event.stopPropagation()">
      <h3 class="text-lg font-semibold mb-2">Edición masiva de repuestos</h3>
      <p class="text-sm text-gray-600 mb-4">
        Completá solo los campos que quieras cambiar. Si un campo queda vacío, no se modifica.
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Estado del Producto</label>
          <select [(ngModel)]="bulkEditForm.productStatus"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option *ngFor="let status of sparePartDeliveryStatus" [value]="status">{{ status }}</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Estado enviado/no enviado</label>
          <select [(ngModel)]="bulkEditForm.shippingStatus"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option value="ENVIADO">ENVIADO</option>
            <option value="NO-ENVIADO">NO-ENVIADO</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Estado llegó/no llegó</label>
          <select [(ngModel)]="bulkEditForm.receptionStatus"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option value="LLEGO">LLEGO</option>
            <option value="NO-LLEGO">NO-LLEGO</option>
          </select>
        </div>
        <div>
          <div class="flex items-center justify-between mb-1">
            <label class="block text-sm font-medium text-gray-700">Color</label>
            <button *ngIf="bulkEditForm.color" type="button" class="text-xs text-gray-500 hover:text-gray-700"
              (click)="clearBulkAldanaColor()">
              No modificar
            </button>
          </div>
          <div class="flex flex-wrap gap-2 min-h-[38px] items-center">
            <button *ngFor="let color of aldanaColorOptions"
              type="button"
              class="w-8 h-8 border rounded"
              [title]="color.name"
              [ngStyle]="{
                'background-color': color.hex,
                'border-color': bulkEditForm.color === color.value ? '#2563eb' : '#9ca3af',
                'box-shadow': bulkEditForm.color === color.value ? '0 0 0 2px rgba(37,99,235,0.35)' : 'none'
              }"
              (click)="selectBulkAldanaColor(color.value)">
            </button>
            <span *ngIf="!bulkEditForm.color" class="text-sm text-gray-400">No modificar</span>
          </div>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Comentario interno</label>
          <input type="text" [(ngModel)]="bulkEditForm.interno" placeholder="No modificar"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
          <label class="mt-2 flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
            <input type="checkbox" [(ngModel)]="bulkEditForm.internoAppend" class="rounded border-gray-300">
            Agregar al existente (en vez de reemplazar)
          </label>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Comentario externo</label>
          <input type="text" [(ngModel)]="bulkEditForm.externo" placeholder="No modificar"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
          <label class="mt-2 flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
            <input type="checkbox" [(ngModel)]="bulkEditForm.externoAppend" class="rounded border-gray-300">
            Agregar al existente (en vez de reemplazar)
          </label>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Check control</label>
          <select [(ngModel)]="bulkEditForm.control"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option value="true">SI</option>
            <option value="false">NO</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Anulado</label>
          <select [(ngModel)]="bulkEditForm.anulado"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option value="true">SI</option>
            <option value="false">NO</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Recompra</label>
          <select [(ngModel)]="bulkEditForm.recompra"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option value="true">SI</option>
            <option value="false">NO</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Enviar</label>
          <select [(ngModel)]="bulkEditForm.sendYesOrNo"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option value="true">SI</option>
            <option value="false">NO</option>
          </select>
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-gray-700 mb-1">NCM</label>
          <input type="text" [(ngModel)]="bulkEditForm.ncm" placeholder="No modificar"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-gray-700 mb-1">Nota fiscal</label>
          <input type="text" [(ngModel)]="bulkEditForm.taxNote" placeholder="No modificar"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-gray-700 mb-1">Número de exportación</label>
          <input type="text" [(ngModel)]="bulkEditForm.exportNumber" placeholder="No modificar"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Estado de devolución</label>
          <select [(ngModel)]="bulkEditForm.returnStatus"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option *ngFor="let option of returnStatusOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Estado de devolución LOG</label>
          <select [(ngModel)]="bulkEditForm.returnLogStatus"
            class="w-full border border-gray-300 rounded-md px-3 py-2">
            <option value="">No modificar</option>
            <option *ngFor="let option of returnLogStatusOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
      </div>

      <div class="mt-4 p-3 rounded-md bg-gray-50 border border-gray-200">
        <div class="text-sm font-semibold text-gray-700 mb-1">Resumen previo</div>
        <div class="text-sm text-gray-600 mb-2">
          Total de repuestos objetivo: {{ selectedCount }}
        </div>
        <ul class="text-sm text-gray-700 list-disc list-inside" *ngIf="getBulkEditSummaryLines().length > 0; else noBulkChanges">
          <li *ngFor="let line of getBulkEditSummaryLines(); trackBy: trackByIndex">{{ line }}</li>
        </ul>
        <ng-template #noBulkChanges>
          <p class="text-sm text-amber-700">No hay cambios configurados todavía.</p>
        </ng-template>
      </div>

      <div class="flex justify-end gap-2 mt-5">
        <button
          type="button"
          (click)="closeBulkEditSparePartsModal()"
          [disabled]="applyingBulkEdit"
          class="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700">
          Cancelar
        </button>
        <button
          type="button"
          (click)="applyBulkEditToSelectedSpareParts()"
          [disabled]="applyingBulkEdit"
          class="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white">
          {{ applyingBulkEdit ? 'Aplicando...' : 'Aplicar cambios' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal peso / país + generación de paquetes -->
  <div *ngIf="openMultiEditModal" class="fixed inset-0 z-[60] bg-black bg-opacity-50 flex items-center justify-center p-4">
    <div class="multi-edit-modal-panel bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[92vh] flex flex-col" (click)="$event.stopPropagation()">
      <div class="p-4 border-b flex justify-between items-start gap-2 shrink-0">
        <div>
          <h3 class="text-lg font-semibold">Peso, país y paquetes (por repuesto)</h3>
          <p class="text-sm text-gray-600 mt-1">
            Completá solo lo que quieras cambiar. Los campos vacíos no modifican el repuesto.
            Después de <strong>Guardar edición</strong> podés generar paquetes (uno por cada grupo de paquete dentro de la orden).
          </p>
        </div>
        <button type="button" class="text-gray-500 hover:text-gray-800" (click)="closeMultiEditSparePartsModal()"
          [disabled]="applyingMultiEditSave || generatingPackagesFromMultiEdit">
          <i class="fas fa-times text-xl"></i>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto p-4 relative min-h-[120px]">
        <div *ngIf="loadingMultiEditModal" class="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
          <span class="text-gray-600"><i class="fas fa-spinner fa-spin mr-2"></i>Cargando repuestos…</span>
        </div>

        <p *ngIf="!loadingMultiEditModal && multiEditRows.length === 0" class="text-sm text-amber-700">No hay repuestos en el modal.</p>

        <div class="space-y-3" *ngIf="!loadingMultiEditModal && multiEditRows.length > 0">
          <div *ngFor="let row of multiEditRows; trackBy: trackByMultiEditRow" class="multi-edit-card border border-gray-200 rounded-lg p-3 bg-gray-50/80">
            <div class="font-medium text-gray-900 mb-2">{{ multiEditPieceDisplayName(row) }}</div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 text-sm text-gray-700 mb-3">
              <div><span class="text-gray-500">Siniestro:</span> {{ row.sparePart.siniestro || '—' }}</div>
              <div><span class="text-gray-500">Cód. referencia:</span> {{ row.sparePart.productCode || '—' }}</div>
              <div class="sm:col-span-2"><span class="text-gray-500">N.º exportación:</span> {{ row.sparePart.exportNumber?.trim() || '—' }}</div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-4 gap-2">
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1">Peso líquido</label>
                <input type="text" [(ngModel)]="row.netInput" (ngModelChange)="onMultiEditRowChanged()"
                  placeholder="Sin cambiar"
                  class="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm" />
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1">Peso bruto</label>
                <input type="text" [(ngModel)]="row.grossInput" (ngModelChange)="onMultiEditRowChanged()"
                  placeholder="Sin cambiar"
                  class="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm" />
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1">País</label>
                <input type="text" [(ngModel)]="row.countryInput" (ngModelChange)="onMultiEditRowChanged()"
                  placeholder="Sin cambiar"
                  class="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm" />
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1">Grupo paquete</label>
                <input type="text" [(ngModel)]="row.packageGroupInput" (ngModelChange)="onMultiEditRowChanged()"
                  placeholder="Ej: 1"
                  class="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-4 border-t shrink-0 bg-gray-50 rounded-b-lg space-y-2">
        <p *ngIf="!multiEditPhysicalSaved && multiEditRows.length > 0" class="text-xs text-amber-800">
          Generar paquetes está desactivado hasta que guardes la edición.
        </p>
        <div class="flex flex-wrap justify-end gap-2">
          <button type="button" (click)="closeMultiEditSparePartsModal()"
            [disabled]="applyingMultiEditSave || generatingPackagesFromMultiEdit"
            class="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm">
            Cerrar
          </button>
          <button type="button" (click)="applyMultiEditPhysical()"
            [disabled]="applyingMultiEditSave || generatingPackagesFromMultiEdit || loadingMultiEditModal || multiEditRows.length === 0"
            class="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-sm">
            {{ applyingMultiEditSave ? 'Guardando…' : 'Guardar edición' }}
          </button>
          <button type="button" (click)="startGeneratePackagesFromMultiEdit()"
            [disabled]="!multiEditPhysicalSaved || generatingPackagesFromMultiEdit || applyingMultiEditSave || loadingMultiEditModal || multiEditRows.length === 0"
            class="px-4 py-2 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-sm">
            {{ generatingPackagesFromMultiEdit ? 'Procesando…' : 'Generar paquetes' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal asignación masiva de exportación -->
  <div *ngIf="openAssignExportModal" class="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-md p-5" (click)="$event.stopPropagation()">
      <h3 class="text-lg font-semibold mb-4">Asignar exportación masiva</h3>
      <p class="text-sm text-gray-600 mb-4">
        Ingresa un número de exportación y una fecha. Se aplicará a todos los repuestos que compartan ese número.
      </p>

      <div class="mb-3">
        <label class="block text-sm font-medium text-gray-700 mb-1">Número de exportación</label>
        <input
          type="text"
          [(ngModel)]="exportNumberToAssign"
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="Ej: EXP-2026-001">
      </div>

      <div class="mb-5">
        <label class="block text-sm font-medium text-gray-700 mb-1">Fecha de exportación</label>
        <input
          type="date"
          [(ngModel)]="exportDateToAssign"
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      </div>

      <div class="flex justify-end gap-2">
        <button
          type="button"
          (click)="closeAssignExportInfoModal()"
          [disabled]="assigningExportInfo"
          class="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700">
          Cancelar
        </button>
        <button
          type="button"
          (click)="submitAssignExportInfo()"
          [disabled]="assigningExportInfo"
          class="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white">
          {{ assigningExportInfo ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Menú de filtros por columna (multi-selección, altura dinámica para no cortarse). -->
  <div *ngIf="activeFilterMenu" class="fixed inset-0 z-40" (click)="closeColumnFilterMenu(false)"></div>
  <div *ngIf="activeFilterMenu" class="fixed bg-white border-2 border-blue-500 rounded-lg shadow-2xl p-4 z-50 w-80 flex flex-col overflow-hidden"
    [style.left.px]="filterMenuPosition.x" [style.top.px]="filterMenuPosition.y"
    [style.max-height.px]="filterMenuMaxHeight" (click)="$event.stopPropagation()">
    <div class="mb-3 flex-shrink-0">
      <label class="block text-sm font-semibold text-gray-700 mb-2">
        Filtrar por {{ activeFilterMenu }}
      </label>
      <input type="text" [(ngModel)]="filterSearchTerm" (ngModelChange)="filterSearchTerm = $event"
        (keyup.enter)="closeColumnFilterMenu(true)"
        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
        placeholder="Buscar o escriba un valor..." />
      <button
        type="button"
        (click)="toggleAllVisibleFilterValues(activeFilterMenu)"
        [disabled]="loadingUniqueValues || getFilteredUniqueValues(activeFilterMenu).length === 0"
        class="mt-2 text-xs font-medium text-blue-600 hover:text-blue-700 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors">
        {{ areAllVisibleFilterValuesSelected(activeFilterMenu) ? 'Deseleccionar todo' : 'Seleccionar todo' }}
      </button>
    </div>
    <div class="mb-3 min-h-0 flex-1 overflow-y-auto border border-gray-200 rounded-md">
      <div *ngIf="loadingUniqueValues" class="p-3 text-sm text-gray-500 text-center">
        Cargando valores...
      </div>
      <div *ngIf="!loadingUniqueValues && getFilteredUniqueValues(activeFilterMenu).length === 0" class="p-3 text-sm text-gray-500 text-center">
        No se encontraron valores
      </div>
      <ng-container *ngIf="!loadingUniqueValues">
        <label *ngFor="let value of getFilteredUniqueValues(activeFilterMenu); trackBy: trackByIndex" 
          class="flex items-center px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm border-b border-gray-100 last:border-b-0 transition-colors">
          <input type="checkbox" class="mr-2" [checked]="isValueSelected(activeFilterMenu, value)"
            (change)="toggleFilterValue(activeFilterMenu, value, $event)">
          <span>{{ value || '(vacío)' }}</span>
        </label>
      </ng-container>
    </div>
    <div class="flex justify-end gap-2 flex-shrink-0 pt-1">
      <button (click)="closeColumnFilterMenu(false)"
        class="px-4 py-2 text-sm bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md transition-colors">
        Cancelar
      </button>
      <button (click)="clearAndApplyColumnFilter()"
        class="px-4 py-2 text-sm bg-red-100 hover:bg-red-200 text-red-700 rounded-md transition-colors">
        Limpiar
      </button>
      <button (click)="closeColumnFilterMenu(true)"
        class="px-4 py-2 text-sm bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors">
        <i class="fas fa-filter mr-1"></i>Aplicar
      </button>
    </div>
  </div>
</div>